import React from "react";
import CrudPage from "../../components/admin/CrudPage";

const TYPE_OPTIONS = [
  { value: "hospital", label: "Hospital" },
  { value: "clinica", label: "Clínica" },
  { value: "farmacia", label: "Farmacia" },
  { value: "gobierno", label: "Sector público" },
  { value: "dental", label: "Dental" },
  { value: "lab", label: "Laboratorio" },
  { value: "vet", label: "Veterinaria" },
];

const config = {
  title: "Clientes",
  eyebrow: "CRM",
  resource: "clients",
  columns: [
    { key: "name", label: "Nombre" },
    { key: "type", label: "Tipo" },
    { key: "city", label: "Ciudad" },
    { key: "contact_name", label: "Contacto" },
    { key: "email", label: "Email" },
    { key: "phone", label: "Teléfono" },
  ],
  fields: [
    { key: "name", label: "Nombre de la institución", required: true },
    { key: "type", label: "Tipo", type: "select", options: TYPE_OPTIONS, required: true },
    { key: "contact_name", label: "Contacto" },
    { key: "email", label: "Email", type: "email" },
    { key: "phone", label: "Teléfono" },
    { key: "city", label: "Ciudad" },
    { key: "state", label: "Estado" },
    { key: "country", label: "País" },
    { key: "notes", label: "Notas", type: "textarea" },
  ],
};

export default function AdminClients() {
  return <CrudPage config={config} />;
}
